<template>
  <div>
    <q-item class="col-6 row justify-start text-h6 text-bold text-blue-10" bordered>訂單號碼 {{cordNo}} {{insNo === '' ? '' : '分納 ' + insNo}}</q-item>
    <div class="q-px-md q-pb-md">
      <q-table
        class="header-table"
        separator= "cell"
        :data="acousticWindowData"
        :columns="windowColumns"
        row-key="seq"
        no-data-label="暫無資料"
        :pagination.sync="pagination"
        :rows-per-page-options="[0]"
        hide-bottom
      >
        <template v-slot:body="props">
          <q-tr class="rwdTr" :props="props">
            <q-td class="rwdTd" data-th="序號" key="seq" :props="props" v-show="props.row.seq !== null">
              <div class="text-center">{{ props.row.seq }}</div>
            </q-td>
            <q-td class="rwdTd" data-th="窗號" key="itemNo" :props="props">
              <a class="link_mission" @click="openWindowDetail(props.row.itemNo)">
                <div class="text-center">{{ props.row.itemNo }}</div>
              </a>
              <!-- <div v-else style="color:gray;">
                <div class="text-center">{{ props.row.itemNo }}</div>
              </div> -->
            </q-td>
            <q-td class="rwdTd" data-th="窗名" key="itemName" :props="props" v-show="props.row.itemName !== null">
              <div class="text-center">{{ props.row.itemName }}</div>
            </q-td>
            <q-td class="rwdTd" data-th="樘數" key="qty" :props="props" v-show="props.row.qty !== null">
              <div class="text-center">{{ props.row.qty }}</div>
            </q-td>
            <q-td class="rwdTd" data-th="整樘 入庫/出庫" key="windowAll" :props="props" >
              <div class="row col-12 q-col-gutter-x-md">
                <div class="col-md-6 col-6 text-center" style="border-right: groove;" v-show="props.row.winProduced !== null">{{ props.row.winProduced }}</div>
                <div class="col-md-6 col-6 text-center" v-show="props.row.winShipped !== null">{{ props.row.winShipped }}</div>
              </div>
            </q-td>
            <q-td class="rwdTd" data-th="外框 入庫/出庫" key="frame" :props="props" >
              <div class="row col-12 q-col-gutter-x-md">
                <div class="col-md-6 col-6 text-center" style="border-right: groove;" v-show="props.row.frameProduced !== null">{{ props.row.frameProduced }}</div>
                <div class="col-md-6 col-6 text-center" v-show="props.row.frameShipped !== null">{{ props.row.frameShipped }}</div>
              </div>
            </q-td>
            <q-td class="rwdTd" data-th="內扇 入庫/出庫" key="inner" :props="props" >
              <div class="row col-12 q-col-gutter-x-md">
                <div class="col-md-6 col-6 text-center" style="border-right: groove;" v-show="props.row.innerProduced !== null">{{ props.row.innerProduced }}</div>
                <div class="col-md-6 col-6 text-center" v-show="props.row.innerShipped !== null">{{ props.row.innerShipped }}</div>
              </div>
            </q-td>
            <q-td class="rwdTd" data-th="紗窗 入庫/出庫" key="net" :props="props" >
              <div class="row col-12 q-col-gutter-x-md">
                <div class="col-md-6 col-6 text-center" style="border-right: groove;"  v-show="props.row.netProduced !== null">{{ props.row.netProduced }}</div>
                <div class="col-md-6 col-6 text-center" v-show="props.row.netShipped !== null">{{ props.row.netShipped }}</div>
              </div>
            </q-td>
            <q-td class="rwdTd" data-th="其他 入庫/出庫" key="other" :props="props" >
              <div class="row col-12 q-col-gutter-x-md">
                <div class="col-md-6 col-6 text-center" style="border-right: groove;" v-show="props.row.otherProduced !== null">{{ props.row.otherProduced }}</div>
                <div class="col-md-6 col-6 text-center" v-show="props.row.otherShipped !== null">{{ props.row.otherShipped }}</div>
              </div>
              <!-- <q-menu content-class="q-pa-xs bg-grey-7 text-white" touch-position>{{ props.row.driver }}</q-menu> -->
            </q-td>
          </q-tr>
        </template>
        <template v-slot:bottom-row>
          <q-tr v-show="acousticWindowData.length === 0">
            <q-td colspan="100%" class="text-center">
              <i class="fas fa-exclamation-triangle">查無資料</i>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <!-- 窗號細項 -->
    <q-dialog v-model="windowDetail" persistent>
      <q-card style="min-width: 80vw;">
        <q-toolbar class="text-blue-8">
          <q-avatar>
            <q-icon name="fas fa-list-alt"></q-icon>
          </q-avatar>
          <q-toolbar-title>
            窗號細項
          </q-toolbar-title>
          <q-btn class="close-icon text-blue-8" flat v-close-popup round dense icon="fas fa-times" />
        </q-toolbar>
        <q-card-section class="row justify-center items-center">
          <div class="q-px-md q-pb-md">
            <q-item class="col-12 justify-start text-h6 text-bold text-blue-10 q-pa-none" bordered>窗號 {{this.itemNo}}</q-item>
            <q-table
              class="header-table"
              separator= "cell"
              :data="acousticWindowDetailData"
              :columns="windowDetailColumns"
              row-key="index"
              no-data-label="暫無資料"
              :pagination.sync="pagination"
              :rows-per-page-options="[0]"
              hide-bottom
            >
              <template v-slot:body="props">
                <q-tr class="rwdTr" :props="props">
                  <q-td class="rwdTd" data-th="序號" key="detailSeq" :props="props" v-show="props.row.seq">
                    <div class="text-center">{{ props.row.seq }}</div>
                  </q-td>
                  <q-td class="rwdTd" data-th="產品編號" key="detailProdNo" :props="props">
                    <div class="text-center">{{ props.row.prodNo }}</div>
                  </q-td>
                  <q-td class="rwdTd" data-th="產品名稱" key="detailProdName" :props="props" v-show="props.row.seq" style="overflow:hidden">
                    <div class="text-center" style="width: 150px; max-width: 150px">{{ props.row.prodName }}</div>
                    <q-menu content-class="q-pa-xs bg-primary text-white" touch-position>{{ props.row.prodName }}</q-menu>
                  </q-td>
                  <q-td class="rwdTd" data-th="外框 入庫/出庫" key="detailFrame" :props="props" >
                    <div class="row col-12">
                      <div class="col-md-6 col-6 text-center" style="border-right: groove;" v-show="props.row.frameProduced !== null">{{ props.row.frameProduced }}</div>
                      <div class="col-md-6 col-6 text-center" v-show="props.row.frameShipped !== null">{{ props.row.frameShipped }}</div>
                    </div>
                  </q-td>
                  <q-td class="rwdTd" data-th="內扇 入庫/出庫" key="detailInner" :props="props" >
                    <div class="row col-12">
                      <div class="col-md-6 col-6 text-center" style="border-right: groove;" v-show="props.row.innerProduced !== null">{{ props.row.innerProduced }}</div>
                      <div class="col-md-6 col-6 text-center" v-show="props.row.innerShipped !== null">{{ props.row.innerShipped }}</div>
                    </div>
                  </q-td>
                  <q-td class="rwdTd" data-th="紗窗 入庫/出庫" key="detailNet" :props="props" >
                    <div class="row col-12 ">
                      <div class="col-md-6 col-6 text-center" style="border-right: groove;"  v-show="props.row.netProduced !== null">{{ props.row.netProduced }}</div>
                      <div class="col-md-6 col-6 text-center" v-show="props.row.netShipped !== null">{{ props.row.netShipped }}</div>
                    </div>
                  </q-td>
                  <q-td class="rwdTd" data-th="其他 入庫/出庫" key="detailOther" :props="props" >
                    <div class="row col-12 ">
                      <div class="col-md-6 col-6 text-center" style="border-right: groove;" v-show="props.row.otherProduced !== null">{{ props.row.otherProduced }}</div>
                      <div class="col-md-6 col-6 text-center" v-show="props.row.otherShipped !== null">{{ props.row.otherShipped }}</div>
                    </div>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script type="text/javascript">
import { commonMixin } from '@/common/js/mixins'

export default {
  name: 'QtyProduction',
  props: {
    cordNo: {
      type: String,
      default: ''
    },
    insNo: {
      type: String,
      default: ''
    },
    winFlag: {
      type: Boolean,
      default: false
    }
  },
  mixins: [commonMixin],
  components: {},
  watch: {
    'cordNo' (nval, oval) {
      if (nval !== '' && this.insNo === '') {
        this.updateWindowByCordNo()
      }
    },
    'insNo' (nval, oval) {
      if (nval !== '' && this.cordNo !== '') {
        this.updateWindowByCordNoAndInsNo()
      } else if (nval === '' && this.cordNo !== '') {
        // 僅點選訂單號
        this.updateWindowByCordNo()
      }
    }
  },
  mounted () {
    this.itemNo = ''
  },
  created () {},
  data () {
    return {
      pagination: {
        rowsPerPage: 0
      },
      windowDetail: false,
      // 窗戶資訊
      windowColumns: [
        { name: 'seq', label: '序號', field: 'seq', align: 'center', sortable: true },
        { name: 'itemNo', label: '窗號', field: 'itemNo', align: 'center', sortable: true },
        { name: 'itemName', label: '窗名', field: 'itemName', align: 'center', sortable: true },
        { name: 'qty', label: '樘數', field: 'qty', align: 'center' },
        { name: 'windowAll', label: '整樘 入庫/出庫', field: 'windowAll', align: 'center' },
        { name: 'frame', label: '外框 入庫/出庫', field: 'frame', align: 'center' },
        { name: 'inner', label: '內扇 入庫/出庫', field: 'inner', align: 'center' },
        { name: 'net', label: '紗窗 入庫/出庫', field: 'met', align: 'center' },
        { name: 'other', label: '其他 入庫/出庫', field: 'met', align: 'center' }
      ],
      // 窗戶組件資訊
      windowDetailColumns: [
        { name: 'detailSeq', label: '序號', field: 'detailSeq', align: 'center', sortable: true },
        { name: 'detailProdNo', label: '產品編號', field: 'detailProdNo', align: 'center', sortable: true },
        { name: 'detailProdName', label: '產品名稱', field: 'detailProdName', align: 'center', sortable: true },
        { name: 'detailFrame', label: '外框 入庫/出庫', field: 'detailFrame', align: 'center' },
        { name: 'detailInner', label: '內扇 入庫/出庫', field: 'detailInner', align: 'center' },
        { name: 'detailNet', label: '紗窗 入庫/出庫', field: 'detailNet', align: 'center' },
        { name: 'detailOther', label: '其他 入庫/出庫', field: 'detailOther', align: 'center' }
      ],
      // 訂單窗戶資訊
      acousticWindowData: [],
      acousticWindowDetailData: [],
      itemNo: ''
    }
  },
  methods: {
    openWindowDetail (itemNo) {
      // 跳窗 窗戶細項使用
      this.itemNo = itemNo
      // 傳入參數
      let param = {
        itemNo: itemNo,
        cordNo: this.cordNo,
        insNo: this.insNo
      }
      this.get('getWindowDetail', param, r => {
        if (r.length > 0) {
          this.windowDetail = true
          this.acousticWindowDetailData = r
        } else {
          this.message('此窗號無細項資料！')
        }
      })
    },
    // 根據 訂單號查詢 窗號入出庫資料
    updateWindowByCordNo () {
      // 清除資料
      this.acousticWindowData = []
      console.log(`update By cordNo : ${this.cordNo}`)
      this.get('getWindowInfo', { cordNo: this.cordNo }, r => {
        if (r.length > 0) {
          // 開啟此區塊
          this.$emit('update:winFlag', true)
          this.acousticWindowData = r
        } else {
          // 隱藏此區塊
          // this.$emit('update:winFlag', false)
        }
      })
    },
    // 根據 訂單號與分納查詢
    updateWindowByCordNoAndInsNo () {
      // 清除資料
      this.acousticWindowData = []
      console.log(`update By cordNo : ${this.cordNo} and insNo : ${this.insNo} `)
      this.get('getWindowInfo', { cordNo: this.cordNo, insNo: this.insNo }, r => {
        if (r.length > 0) {
          // 開啟此區塊
          this.$emit('update:winFlag', true)
          this.acousticWindowData = r
        } else {
          // 隱藏此區塊
          // this.$emit('update:winFlag', false)
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
